import { render, staticRenderFns } from "./Flutterwave.vue?vue&type=template&id=6bcf28c5&"
import script from "./Flutterwave.vue?vue&type=script&lang=js&"
export * from "./Flutterwave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports